export interface IRefundReceivedChecksRequest {
  refundCheckDate: string
  refundCheckNumber: string
  refundAmount: number
  refundNote: string
  checkNumber: number
  checkDate: Date
  payer: string
}

export class RefundReceivedChecksRequest implements IRefundReceivedChecksRequest {
  public refundCheckDate: string
  public refundCheckNumber: string
  public refundAmount: number
  public refundNote: string
  public checkNumber: number
  public checkDate: Date
  public payer: string
}
